import useReveal from "@/hooks/useReveal";
import { HOME } from "@/constants/testIds";

const SIGNATURE = [
  {
    n: "01",
    title: "Audiences with Artisans",
    text: "Private sessions with master craftsmen — block printers in Bagru, thangka painters in Bhaktapur, ola-leaf scribes in Galle.",
  },
  {
    n: "02",
    title: "Heritage Stays",
    text: "Forts, palaces, monastic retreats and tea-estate bungalows — each property a curated chapter of its region's history.",
  },
  {
    n: "03",
    title: "Quiet Ceremonies",
    text: "Dawn pujas at private temples, monastic blessings in Paro, and lakeside meditations in the Annapurna foothills.",
  },
  {
    n: "04",
    title: "The Slow Table",
    text: "Heritage menus prepared by royal chefs, family kitchens, and forgotten regional traditions across South Asia.",
  },
];

export default function SignatureSection() {
  const r = useReveal();
  return (
    <section
      ref={r}
      data-testid={HOME.experiencesSection}
      className="relative py-32 md:py-40"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="eyebrow mb-6">Signature Experiences</div>
        <h2 className="font-serif text-5xl md:text-6xl tracking-tight font-light max-w-3xl mb-20">
          Small, deliberate <em className="italic text-indigo_deep">moments of access</em>.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
          {SIGNATURE.map((s) => (
            <div key={s.n} className="group flex gap-8 border-t border-line-dark pt-10">
              <div className="font-serif text-3xl text-goldleaf font-light">{s.n}</div>
              <div>
                <h3 className="font-serif text-3xl md:text-4xl font-light leading-tight mb-4 group-hover:text-indigo_deep transition-colors">
                  {s.title}
                </h3>
                <p className="text-ink/70 leading-relaxed font-light max-w-md">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
